export default __webpack_public_path__ + "static/media/bike.e740a070.png";